<template>
	<div>
		<div class="container">
			<div>
				<el-button size="small" type="primary" :class="[theme]" class="m_l_10" @click="getData">刷新</el-button>
				<el-button size="small" type="primary" :class="[theme]" class="m_l_10" @click="showAdd">添加</el-button>
				<el-button size="small" type="primary" :class="[theme]" class="m_l_10"
					@click="getOperationReset">重置计数</el-button>
			</div>
			<div class="card-body fade-in" v-if="dataTotal">

				<div class="card-list">
					<div class="card-item fade-in">
						<span class="card-list-tit">服务器数量</span>
						<span class="card-list-data">{{tableData.length||0}}台</span>
					</div>
					<div class="card-item fade-in">
						<span class="card-list-tit">服务器总请求次数</span>
						<span class="card-list-data">{{dataTotal.totalreq||0}}次</span>
					</div>
					<div class="card-item fade-in">
						<span class="card-list-tit">服务器成功处理总次数</span>
						<span class="card-list-data">{{dataTotal.totalsus||0}}次</span>
					</div>
					<div class="card-item fade-in">
						<span class="card-list-tit">服务器总检测时长</span>
						<span class="card-list-data">{{dataTotal.totaldurationSeconds.toFixed(2)||0}}分钟</span>
					</div>
					<div class="card-item fade-in">
						<span class="card-list-tit">录音有效率</span>
						<span
							class="card-list-data">{{(dataTotal.totalsus/dataTotal.totalreq).toFixed(2)*100||0}}%</span>
					</div>
				</div>
			</div>
			<el-table :data="tableData" v-loading="loading" border class="table m_t_20" max-height="600"
				header-cell-class-name="table-header" :row-style="{ height: '20px' }"
				:header-cell-style="{ 'text-align': 'center' }" :cell-style="{ padding: '6px' }" stripe>
				<el-table-column prop="instanceId" label="服务器名称" align="center"></el-table-column>
				<el-table-column prop="status" label="服务器状态" align="center" width="120"></el-table-column>
				<el-table-column prop="cpu" label="CPU" align="center" width="120" sortable></el-table-column>
				<el-table-column prop="req" label="总请求数量" align="center" width="120" sortable></el-table-column>
				<el-table-column prop="sus" label="成功请求数量" align="center" width="120" sortable></el-table-column>
				<el-table-column prop="duration_seconds" label="检测时长" align="center" width="120" sortable>
					<template #default="scope">{{scope.row.duration_seconds||0}}分钟</template>
				</el-table-column>
				<el-table-column prop="time" label="运行时长" align="center" width="120" sortable>
					<template #default="scope">{{scope.row.time||0}}分钟</template>
				</el-table-column>
				<el-table-column prop="avgMin" label="分钟检测时长" align="center" width="120" sortable>
					<template #default="scope">{{scope.row.avgMin||0}}
						分钟</template>
				</el-table-column>
				<el-table-column prop="configuration" label="配置" align="center" width="120"></el-table-column>
				<el-table-column label="操作" align="center" width="300">
					<template #default="scope">
						<el-button size="small" type="danger" @click.stop="handleDelete(scope.row)"
							class="red">删除</el-button>
						<el-button size="small" type="primary" :class="[theme]"
							@click.stop="handleEdit(scope.row)">修改</el-button>
						<el-button size="small" type="primary" :class="[theme]" @click.stop="openClose(scope.row)"
							v-if="scope.row.instanceStatus=='Stopped'">开启</el-button>
						<el-button size="small" type="primary" :class="[theme]" @click.stop="openClose(scope.row)"
							v-if="scope.row.instanceStatus=='Running'">关闭</el-button>
						<el-button size="small" type="primary" :class="[theme]" @click.stop="getStatus(scope.row)"
							v-if="scope.row.instanceStatus=='Running'">状态</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<el-dialog title="添加" v-model="addVisible" width="400px" @close="closeDialog" :close-on-click-modal="false">
			<el-form :model="addform" :rules="rules" ref="addform" label-width="100px">
				<el-form-item label="服务器名称" prop="name">
					<el-input size="small" v-model="addform.instanceId"></el-input>
				</el-form-item>
				<el-form-item class="dis-end">
					<el-button size="small" @click="closeDialog">取消</el-button>
					<el-button size="small" :class="[theme]" type="primary" @click="getAdd">确定</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<el-dialog title="服务状态" v-model="statusVisible" width="1000px" @close="closeDialog"
			:close-on-click-modal="false">
			<span style="white-space: pre-line;line-height: 40px;">{{statusForm}}</span>
		</el-dialog>
	</div>
</template>
<script>
	import {
		getOperationList,
		getAddOrUpdate,
		getDeleteServer,
		getOperation,
		serviceStatus,
		operationReset
	} from '../../api/inspection.js';
	export default {
		name: 'inspectionServer',
		data() {
			return {
				loading: false,
				theme: localStorage.getItem('theme'),
				theme3: localStorage.getItem('theme3'),
				theme8: localStorage.getItem('theme8'),
				tableData: [],
				addVisible: false,
				addform: {
					instanceId: '',
					id: ''
				},
				statusVisible: false,
				statusForm: '',
				dataTotal: ''
			};
		},
		created() {
			this.getData()
		},
		methods: {
			getData() {
				this.loading = true;
				getOperationList().then(res => {
					this.loading = false;
					if (res?.code === 200) {
						this.tableData = res.data;
						const safeCustomData = Array.isArray(res.data) ? res.data : [];
						this.dataTotal = safeCustomData.reduce((acc, item) => {
							acc.totalreq += item.req || 0; // 额外防止 item.total 未定义
							acc.totalsus += item.sus || 0; // 额外防止 item.total 未定义
							acc.totaldurationSeconds += parseFloat(item.duration_seconds) ||
								0; // 额外防止 item.total 未定义

							return acc;
						}, {
							totalreq: 0,
							totalsus: 0,
							totaldurationSeconds: 0,
						});
					} else {
						this.$message.error(res.message);
					}
				});
			},
			getOperationReset() {
				operationReset().then(res => {
					if (res?.code === 200) {
						this.$message.success(res.data);
					} else {
						this.$message.error(res.message);
					}
				});
			},
			handleDelete(row) {
				let data = {
					id: row.id
				}
				getDeleteServer(data).then(res => {
					if (res?.code === 200) {
						this.$message.success(res.message);
						this.getData();
					} else {
						this.$message.error(res.message);
					}
				});
			},
			showAdd() {
				this.addVisible = true;
			},
			closeDialog() {
				this.addform.instanceId = '';
				this.addform.id = '';
				this.addVisible = false;
				this.statusVisible = false;
			},
			getAdd() {
				getAddOrUpdate(this.addform).then(res => {
					if (res?.code === 200) {
						this.$message.success(res.message);
						this.addVisible = false;
						this.getData();
					} else {
						this.$message.error(res.message);
					}
				});
			},
			openClose(row) {

				let data = {
					instanceId: row.instanceId,
					status: row.instanceStatus == 'Running' ? 'stop' : 'start'
				}
				getOperation(data).then(res => {
					if (res?.code === 200) {
						this.$message.success(res.message);
						this.getData();
					} else {
						this.$message.error(res.message);
					}
				});
			},
			handleEdit(row) {
				this.addform = row;
				this.addVisible = true;
			},
			getStatus(row) {
				let data = {
					instanceId: row.instanceId
				}
				serviceStatus(data).then(res => {
					if (res?.code === 200) {
						this.statusVisible = true;
						this.statusForm = res.data
							.replace(/\\\s*n/g, '<br>') // 将 \n 替换为 <br>
							.replace(/\s*\/\s*/g, '/');
						this.$message.success(res.message);
					} else {
						this.$message.error(res.message);
					}
				});
			},
			// 分页导航
			handlePageChange(val) {
				this.query.current = val;
				this.getData();
			},
			handleSizeChange(val) {
				this.query.size = val;
				this.query.current = 1; // 重置到第一页
				this.getData();
			},
		}
	};
</script>
<style scoped>
	.handle-select {
		width: 120px;
	}

	.table {
		width: 100%;
		font-size: 12px;
	}



	.card-body {
		background: #ffffff;
		border-radius: 16px;
		/* box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08); */
		overflow: hidden;
		transition: transform 0.3s ease, box-shadow 0.3s ease;
		margin-top: 14px;
	}

	.card-body:hover {
		transform: translateY(-5px);
		/* box-shadow: 0 15px 35px rgba(0, 0, 0, 0.12); */
	}

	.tit {
		background: linear-gradient(135deg, #4f7afd 0%, #6c6cf9 100%);
		padding: 20px 25px;
		color: #ffffff;
		display: flex;
		align-items: center;
		border-bottom: 1px solid rgba(255, 255, 255, 0.1);
	}

	.tit div {
		display: flex;
		align-items: center;
		font-size: 1.3rem;
		font-weight: 600;
	}

	.tit i {
		margin-right: 12px;
		font-size: 1.5rem;
	}

	.card-list {
		display: flex;
		flex-wrap: wrap;
		gap: 20px;
	}

	.card-item {
		flex: 1;
		background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
		border-radius: 12px;
		padding: 10px 25px;
		/* box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05); */
		transition: all 0.3s ease;
		position: relative;
		overflow: hidden;
		cursor: pointer;
	}

	.card-item:hover {
		transform: translateY(-5px);
		/* box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1); */
	}

	/* .card-item::before {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		width: 5px;
		height: 100%;
		background: #4f7afd;
	} */

	.card-list-tit {
		display: block;
		font-size: 1.1rem;
		color: #7f8c8d;
		margin-bottom: 15px;
		font-weight: 600;

	}

	.card-list-data {
		display: block;
		font-size: 2rem;
		font-weight: 700;
		color: #2c3e50;
		margin-bottom: 10px;
		transition: all 0.3s ease;
	}

	.card-item:hover .card-list-data {
		color: #4f7afd;
	}
</style>